import React, { useRef, useState } from "react";
import styled from "styled-components";
import { Calendar } from "../../assets/icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.css";
import { Text } from "../../TextConstants";
import { Colors } from "../../ColorConstants";
// import { KeyboardAvoidingView } from "react-native";

const CalendarPicker = ({
  onSetDate,
  date,
  error,
  minDate,
  maxDate,
  showHelper = true,
  filterDate,
}) => {
  const datepickerRef = useRef(null);
  // let today = new Date();
  // let minDay = minDate ? new Date(minDate) : null;
  return (
    <Styledcalendar>
      <Title>{Text.calendarTitle}</Title>
      <DateDiv>
        <StyledDatePicker
          minDate={minDate}
          maxDate={maxDate}
          selected={date}
          readonly
          value={date}
          onSelect={(date) => onSetDate(date)}
          placeholderText="yyyy-mm-dd"
          ref={datepickerRef}
          dateFormat="yyyy-MM-dd"
          popperModifiers={{
            offset: {
              enabled: true,
              offset: "0, 10px",
            },
            preventOverflow: {
              enabled: true,
              escapeWithReference: false,
              boundariesElement: "viewport",
            },
          }}
          filterDate={filterDate || false}
        />

        <CalendarIcon
          src={Calendar}
          onClick={() => datepickerRef.current.setOpen(true)}
          inputMode="none"
        />
      </DateDiv>
      {error && <ErrorHelperText>{error}</ErrorHelperText>}
      {showHelper && <HelperText>{Text.calendarHelperText}</HelperText>}
    </Styledcalendar>
  );
};

export default CalendarPicker;
const ErrorHelperText = styled.div`
  font-size: 0.75rem;
  color: red;
`;
const HelperText = styled.div`
  margin-top: 0.5rem;
  font-size: 0.75rem;
  color: ${Colors.grey};
`;
const Styledcalendar = styled.div`
  width: 100%;
  margin-top: 0.6rem;
  @media only screen and (max-width: 1024px) {
    margin-top: 0rem;
  }
`;

const Title = styled.div`
  color: ${Colors.black};
  font-family: Poppins;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
`;

const DateDiv = styled.div`
  display: flex;
  align-items: flex-end;
  position: relative;
  width: 100%;
`;

const StyledDatePicker = styled(DatePicker)`
  border-bottom: 1px solid ${Colors.grey40};
  border-top: none;
  border-left: none;
  border-right: none;
  height: 2rem;
  width: 100%;
  outline: none;
  background: none;
  color: ${Colors.black};
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;

  &::placeholder {
    color: ${Colors.lightBlack};
    font-weight: 500;
  }

  .custom-calendar {
    /* Calendar container */
    font-family: Arial, sans-serif;
    border: 1px solid red;
    border-radius: 8px;
    box-shadow: 0 2px 4px ${Colors.lightBlack2};
    position: absolute;
    bottom: 10px;
  }

  .react-datepicker-header {
    /* Header at the top of the calendar */
    background-color: ${Colors.darkCharcoal};
    color: ${Colors.white};
  }

  .react-datepicker-title {
    /* Title of the calendar (Month and Year) */
    font-weight: 600;
  }

  .react-datepicker-day-name {
    /* Day names (e.g., Sun, Mon, Tue, etc.) */
    color: ${Colors.darkCharcoal};
  }

  .react-datepicker-day {
    /* Individual day cells */
    color: ${Colors.black};
  }

  .react-datepicker-today {
    /* Style for today's date */
    font-weight: 600;
  }

  .react-datepicker-selected {
    /* Style for the selected date */
    background-color: ${Colors.darkCharcoal};
    color: ${Colors.white};
  }
`;

const CalendarIcon = styled.img`
  height: 1.5rem;
  width: 1.5rem;
  position: absolute;
  right: 0;
  padding-bottom: 7px;
  cursor: pointer;
`;
